import { getApiClient, initializeApiClient } from "../apiService";
export const UpdateOtherMainSectors = async (AI_SecondarySectorsId,SecondarySectors) => {
    await initializeApiClient();
    const apiClient = await getApiClient();
    const response = await apiClient.post("api/AI_SecondarySectors/UpdateAI_SecondarySectors", {
        AI_SecondarySectorsId:AI_SecondarySectorsId,
        aI_SubSectorId: SecondarySectors.aI_SubSectorId,
        aI_MainSectorId: SecondarySectors.aI_MainSectorId,
        aI_ApplicationInformationId: SecondarySectors.aI_ApplicationInformationId
    });

    return response
}